export const updateCancelOrder = order => ({
  type: 'UPDATE_CANCEL_ORDER',
  payload: order,
});

export const pushBeforeCancelOrder = (order) => ({
  type: "PUSH_BEFORE_CANCEL_ORDER",
  payload: order,
});
